import Link from "next/link";
import { useState, useEffect } from "react";
interface props {
  color: string;
  source: string;
  title: string;
}

export default function PlagResultCard({ color, source, title }: props) {
  const handleOpenLinkInNewTab = (source: string, e: any) => {
    e.preventDefault();
    window.open(source, "_blank");
  };
  return (
    <Link href={source}>
      <div
        className="flex flex-row w-full h-32 rounded-xl bg-[#24314C]
    border-b-lg border-b-4 justify-center items-center p-2 m-2"
        style={{
          borderColor: color,
        }}
      >
        <div className="w-full flex flex-col">
          <div className="text-xs xs:text-sm text-white line-clamp-2 mr-1 font-medium">
            <p>{title}</p>
          </div>
        </div>
      </div>
    </Link>
  );
}
